/*LIBRARY*/
import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import centroid from "@turf/centroid";
import { ArrowBackIos, MoreVert } from "@material-ui/icons";
import { featureCollection } from "@turf/helpers";
import bbox from "@turf/bbox";

/*COMPONENT*/
import SolidCheckbox from "../reuseable/SolidCheckbox";
import CHART_TEMPLATE from "../viewer_chart/CHART_TEMPLATE";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import Modal from "../common_modal/Modal";

/*REDUX*/
import { set_value_toolbox, toolbox_handle_back } from "../../App/actions/toolboxActions";
import { push_features, remove_source_and_layer_from_map, toolbox_save_layer } from "../../App/actions/layerNewActions";

/*PICTURE*/
import icon_trash from "../../Assets/svg/icon_trash.svg";
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";

/*FUNCTION*/
import { create_marker_element } from "../libre_layer/LAYER_TOOLBOX";
import { generateField, select_field_from_default_props } from "../../App/validation/generateGeoJson";
import { array_to_sentence } from "../../App/validation/text_helper";
import useLanguage from "../common_hooks/useLanguage";
import { post_activities } from "../../App/actions/activities";
import { getDetailLayerById } from "../../App/actions/get_features_action";

/*DATA*/

/*CONST*/

function TOOLBOX_DETAIL_ELEVATION() {

  //local storage
  const { dict, language } = useLanguage();

  //local state
  // const [unit, set_unit] = useState(tool?.unit_options?.[0] || "");
  // const [layer_ids, set_layer_ids] = useState([]);
  const [modal_delete, set_modal_delete] = useState(false);
  const [showing_tab, set_showing_tab] = useState("table");
  const [modal_float, set_modal_float] = useState(false);
  const [anchor, set_anchor] = useState(null);
  const [single_selected, set_single_selected] = useState("");
  const [chart_select_mode, set_chart_select_mode] = useState(false);
  // const [modal_rename_tool, set_modal_rename_tool] = useState(false);
  // const [new_id_tool, set_new_id_tool] = useState("");

  const dispatch = useDispatch();

  //global props
  const toolbox = useSelector((state) => state.toolbox) || {};
  const { map_object } = useSelector((state) => state.layer) || {};
  const auth = useSelector((state) => state.auth) || {};
  const { geo_project } = useSelector((state) => state.project) || {};
  const {
    mode_toolbox,
    uuid_name,
    loading_status,
    loading_item,
    elevation_chart_array,
    last_saved_feature_uuid,
    features_elevation_center,
    modal_cancel_confirmation,
    point_inside_elevation_line,
    start_time
  } = toolbox || {};

  // naming
  const visible_name = mode_toolbox.replace("features", "visible");  // visible_radius
  // const fields_toolbox = mode_toolbox.replace("features", "fields"); // fields_radius
  const source_id = "geojson_elevation";

  // const tool = get_toolbox_mode_list(mode_toolbox);
  // const unit_options = tool?.unit_options || [];
  const visible_features = toolbox?.[visible_name];

  // const fields = toolbox[fields_toolbox];
  const features = toolbox[mode_toolbox];

  const selected_row_toolbox_ids = toolbox[uuid_name];
  const selected_all =
    selected_row_toolbox_ids.length > 0
      ? !features.some((f) => !selected_row_toolbox_ids.includes(f.properties.uuid))
      : false;

  let last_saved_feature_uuid_index;
  if (last_saved_feature_uuid === "") last_saved_feature_uuid_index = Infinity;
  else if (last_saved_feature_uuid === "start") last_saved_feature_uuid_index = -1;
  else {
    // partial save
    last_saved_feature_uuid_index = features.findIndex(
      f => f.properties.uuid === last_saved_feature_uuid
    );
  }



  const [modal_save_tool, set_modal_save_tool] = useState(false);
  // const [modal_save_poi, set_modal_save_poi] = useState(false);
  const [new_layer_name, set_new_layer_name] = useState("");
  // const [modal_mapid_data, set_modal_mapid_data] = useState(false);
  // const selected_layers = geo_layer_list.filter(l => layer_ids.includes(l.geo_layer._id))
  // const is_has_access_sini = dispatch(
  //   is_user_get_access_by_license_key("license_sini_data")
  // );
  const single_selected_feature = features.find(f => f.properties.uuid === single_selected || "");

  // functions
  const on_clear_select = () => {
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    const will_be_change_style = features.filter((f) =>
      visible_features.includes(f.properties.uuid),
    );
    if (!map_object) return;

    will_be_change_style.forEach((f) => {
      map_object.setFeatureState(
        { source: source_id, id: f.properties.uuid },
        { selected: false },
      );
    });
  };


  const on_select_all = () => {
    if (!selected_all) {
      const will_be_selected = features.map((f) => f.properties.uuid);
      dispatch(
        set_value_toolbox({
          key: uuid_name,
          value: will_be_selected,
        }),
      );

      const will_be_change_style = features.filter((f) =>
        visible_features.includes(f.properties.uuid),
      );
      if (!map_object) return;

      will_be_change_style.forEach((f) => {
        map_object.setFeatureState(
          { source: source_id, id: f.properties.uuid },
          { selected: true },
        );
      });
    } else {
      on_clear_select();
    }
  };


  const on_select_row_uuid = async (uuid) => {
    const selected_row_toolbox_ids = toolbox[uuid_name];
    const willBeSelected = !selected_row_toolbox_ids.includes(uuid);

    const updatedIds = willBeSelected
      ? [...selected_row_toolbox_ids, uuid]
      : selected_row_toolbox_ids.filter((id) => id !== uuid);

    // Update Redux
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: willBeSelected
          ? [...selected_row_toolbox_ids, uuid]
          : selected_row_toolbox_ids.filter((id) => id !== uuid),
      }),
    );

    // Set feature state sesuai state yang BARU
    map_object.setFeatureState(
      { source: source_id, id: uuid },
      { selected: willBeSelected }, // ✅ Langsung pake nilai baru
    );

    // 🔥 IMPORTANT: trigger repaint untuk point
    map_object.setPaintProperty(
      "geojson_elevation_point",
      "circle-radius",
      [
        "case",
        [
          "in",
          ["get", "parent_uuid"],
          ["literal", updatedIds]
        ],
        5,
        2
      ]
    );
  };

  const fly_to = (uuid) => {
    if (uuid) {
      const feature = toolbox[mode_toolbox].find(
        (item) => item?.properties?.uuid === uuid,
      );
      const geojson = featureCollection([feature]);
      const feature_center = centroid(geojson);
      const longitude = feature_center?.geometry?.coordinates?.[0];
      const latitude = feature_center?.geometry?.coordinates?.[1];
      if (map_object && longitude && latitude) {
        const bounds = bbox(geojson);
        map_object.flyTo({
          center: [longitude, latitude],
          speed: 1,
          zoom: map_object.cameraForBounds([
            [bounds[0], bounds[1]],
            [bounds[2], bounds[3]]
          ]).zoom
        });
      }
    }
  };


  const on_hide = (uuid) => {
    const { point_inside_elevation_line } = toolbox || {}
    let visible_features = [...toolbox?.[visible_name]];
    if (visible_features.includes(uuid)) {
      visible_features = visible_features.filter((item) => item !== uuid);
    } else {
      visible_features.push(uuid);
    }

    if (!map_object) return;

    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: visible_features,
      }),
    );


    if (map_object?.getSource(source_id)) {
      const geojson_line = featureCollection(
        features.filter((item) =>
          visible_features.includes(item.properties.uuid),
        )
      )
      map_object.getSource(source_id)?.setData(
        geojson_line
      );

    }

    const features_point = [];
    Object.keys(point_inside_elevation_line).filter((uuid) =>
      visible_features.includes(uuid),
    ).forEach((uuid) => features_point.push(...point_inside_elevation_line[uuid]))

    if (map_object?.getSource(`${source_id}_point`)) {
      const geojson_point = featureCollection(features_point)
      map_object.getSource(`${source_id}_point`)?.setData(
        geojson_point
      );
    }

    // label
    features_elevation_center.forEach((feature) => {
      if (visible_features.includes(feature.properties.uuid)) {
        create_marker_element({
          feature,
          uuid_active: feature.properties.uuid,
          map_object,
        });
      } else {
        const marker_to_remove = document.getElementById(
          `marker_toolbox_${uuid}`,
        );
        if (marker_to_remove) {
          marker_to_remove.remove();
        }
      }
    });
  };

  const on_back = (value) => {
    let new_value = !modal_cancel_confirmation?.is_open;
    if (value === false || value === true) {
      new_value = value;
    }

    if (
      last_saved_feature_uuid_index < features.length
    ) {
      dispatch(
        set_value_toolbox({
          key: "modal_cancel_confirmation",
          value: {
            is_open: new_value,
            is_back_active: true,
            tab_value: "",
          },
        }),
      );
    } else {
      dispatch(toolbox_handle_back());
    }
  }

  const handle_tab_change = (e) => {
    const all_uuids = features.map(f => f.properties.uuid);
    if ((!single_selected || !all_uuids.includes(single_selected)) && features?.length > 0) {
      set_single_selected(features?.[0]?.properties?.uuid);
    }
    set_showing_tab(e.target.value)
  }

  const on_hide_all = () => {
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: [],
      }),
    );

    // hapus line dari map
    if (map_object?.getSource(source_id)) {
      const geojson_polygon = featureCollection([])
      map_object.getSource(source_id)?.setData(geojson_polygon);
    }

    // hapus titik-titik elevasi
    if (map_object?.getSource(`${source_id}_point`)) {
      const geojson_polygon = featureCollection([])
      map_object.getSource(`${source_id}_point`)?.setData(geojson_polygon);
    }

    // hapus label titik awal dan terakhir (A dan B) dari map
    if (map_object?.getSource("geojson_distance_label")) {
      const geojson_polygon = featureCollection([])
      map_object.getSource("geojson_distance_label")?.setData(geojson_polygon);
    }

    // hapus label tengah dari map
    features_elevation_center.forEach((feature) => {
      const marker_to_remove = document.getElementById(
        `marker_toolbox_${feature?.properties?.uuid}`,
      );
      if (marker_to_remove) {
        marker_to_remove.remove();
      }
    });
  }

  const on_save = async () => {
    const parent_features = features.filter((f) => selected_row_toolbox_ids.includes(f.properties.uuid));

    const parentMap = {};
    for (const f of parent_features) {
      parentMap[f.properties.uuid] = f.properties.id_tool;
    }

    const features_will_save = [];

    for (const parentUuid in point_inside_elevation_line) {
      const points = point_inside_elevation_line[parentUuid];
      const id_tool = parentMap[parentUuid];

      for (const feature of points) {
        const { parent_uuid, ...restProps } = feature.properties;
        features_will_save.push({
          ...feature,
          properties: {
            ...restProps,
            id_tool
          }
        });
      }
    }

    // console.log("features_will_be_saved", features_will_be_saved);
    const properties = select_field_from_default_props("Point");
    const field_names_will_be_saved = [
      {
        name: "id_tool",
        type: "text",
      },
      {
        name: "distance_m",
        type: "number",
      },
      {
        name: "elevation_m",
        type: "number",
      },
    ];

    const new_fields = [
      ...properties.concat(
        field_names_will_be_saved.map((i) => generateField(i.name, i.type, false))
      ),
    ];

    const body = {
      name: new_layer_name || "New Layer",
      description: "",
      type: "Point",
      folder: "",
      user_id: auth?.user?._id,
      geo_project_id: geo_project._id,
      fields: new_fields,
      properties,
      status: "digitasi",
      architecture: "v2",
    };

    let geo_layer = await dispatch(toolbox_save_layer(body));
    if (!geo_layer) return;

    await dispatch(
      push_features({
        geo_layer_id: geo_layer?._id,
        features: features_will_save,
      }),
    );

    const toolbox_type = mode_toolbox.replace("features_", "").replace("scoring_", "");
    if (start_time) await dispatch(post_activities({ action: `toolbox-${toolbox_type}-save`, duration_ms: new Date() - start_time }));

    set_modal_save_tool(false);
    set_new_layer_name("");

    on_clear_select();
    on_hide_all();

    const body_get = {
      geo_layer_id: geo_layer?._id,
      geo_project_id: geo_project._id,
      flyStatus: true,
      geo_layer_item: geo_layer,
    };
    dispatch(getDetailLayerById(body_get));
  };

  const on_delete = () => {
    const new_features = [];
    const new_features_elevation_center = [];

    features.forEach(
      (f, idx) => {
        if (!selected_row_toolbox_ids.includes(f.properties.uuid)) {
          new_features.push(f);
          new_features_elevation_center.push(features_elevation_center[idx]);
        }
      },
    );

    const new_elevation_chart_array = elevation_chart_array
      .filter(item => !selected_row_toolbox_ids.includes(item.parent_uuid))

    let new_point_inside_elevation_line = structuredClone(point_inside_elevation_line);
    selected_row_toolbox_ids.forEach(uuid => {
      delete new_point_inside_elevation_line[uuid];
    })

    const new_visibles = visible_features.filter(
      (uuid) => !selected_row_toolbox_ids.includes(uuid),
    );

    let new_last = features.filter(
      (f, idx) =>
        last_saved_feature_uuid_index > idx &&
        !selected_row_toolbox_ids.includes(f.properties.uuid),
    );
    let new_last_uuid = new_last?.at(-1)?.properties?.uuid;
    if (new_last.length === 0) {
      new_last_uuid = "start";
    }

    // update yang di mapnya
    if (!map_object) return;

    // set features yang terlihat (dishow)
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: new_visibles,
      }),
    );

    // set features asli
    dispatch(
      set_value_toolbox({
        key: mode_toolbox,
        value: new_features,
      }),
    );

    // set label dari features
    dispatch(set_value_toolbox({
      key: "features_elevation_center",
      value: new_features_elevation_center
    }))

    dispatch(set_value_toolbox({
      key: "point_inside_elevation_line",
      value: new_point_inside_elevation_line
    }))

    dispatch(set_value_toolbox({
      key: "elevation_chart_array",
      value: new_elevation_chart_array
    }))

    if (map_object.getSource(`${source_id}_point`))
      map_object.getSource(`${source_id}_point`)?.setData(
        featureCollection(
          Object.keys(new_point_inside_elevation_line)
            .map(uuid => new_point_inside_elevation_line[uuid])
        )
      );

    if (map_object.getSource(source_id))
      map_object.getSource(source_id)?.setData(
        featureCollection(new_features)
      );


    // label tengah untuk menampilkan/menghapus "D-1" dll
    // dan hapus juga layer poi jika ada
    features_elevation_center.forEach((feature, idx) => {
      if (selected_row_toolbox_ids.includes(feature.properties.uuid)) {
        // hapus marker
        const marker_to_remove = document.getElementById(
          `marker_toolbox_${feature.properties.uuid}`,
        );
        if (marker_to_remove) marker_to_remove.remove();

        // hapus data dan layer poi
        const source_id_poi = `geojson_poi_${feature.properties.uuid}`;
        dispatch(remove_source_and_layer_from_map(source_id_poi));
      }
    });

    // set feature yang diselect
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    dispatch(
      set_value_toolbox({
        key: "last_saved_feature_uuid",
        value: new_last_uuid,
      }),
    );

    set_modal_delete(false);
  };

  const on_single_delete = () => {
    const new_features = [];
    const new_features_elevation_center = [];
    // let new_point_inside_elevation_line = {};

    features.forEach(
      (f, idx) => {
        if (single_selected !== f.properties.uuid) {
          new_features.push(f);
          new_features_elevation_center.push(features_elevation_center[idx]);
        }
      },
    );

    const new_elevation_chart_array = elevation_chart_array
      .filter(item => single_selected !== item.parent_uuid)

    const new_point_inside_elevation_line = Object.keys(point_inside_elevation_line)
      .filter(uuid => single_selected !== uuid)
      .map(uuid => point_inside_elevation_line[uuid]);

    const new_visibles = visible_features.filter(
      (uuid) => single_selected !== uuid,
    );

    let new_last = features.filter(
      (f, idx) =>
        last_saved_feature_uuid_index > idx &&
        single_selected !== f.properties.uuid,
    );
    let new_last_uuid = new_last?.at(-1)?.properties?.uuid;
    if (new_last.length === 0) {
      new_last_uuid = "start";
    }

    // update yang di mapnya
    if (!map_object) return;

    // set features yang terlihat (dishow)
    dispatch(
      set_value_toolbox({
        key: visible_name,
        value: new_visibles,
      }),
    );

    // set features asli
    dispatch(
      set_value_toolbox({
        key: mode_toolbox,
        value: new_features,
      }),
    );

    // set label dari features
    dispatch(set_value_toolbox({
      key: "features_elevation_center",
      value: new_features_elevation_center
    }))

    dispatch(set_value_toolbox({
      key: "point_inside_elevation_line",
      value: new_point_inside_elevation_line
    }))

    dispatch(set_value_toolbox({
      key: "elevation_chart_array",
      value: new_elevation_chart_array
    }))

    if (map_object.getSource(`${source_id}_point`))
      map_object.getSource(`${source_id}_point`)?.setData(
        featureCollection(
          Object.keys(new_point_inside_elevation_line)
            .map(uuid => new_point_inside_elevation_line[uuid])
        )
      );

    if (map_object.getSource(source_id))
      map_object.getSource(source_id)?.setData(
        featureCollection(new_features)
      );


    // label tengah untuk menampilkan/menghapus "D-1" dll
    // dan hapus juga layer poi jika ada
    features_elevation_center.forEach((feature) => {
      if (single_selected === feature.properties.uuid) {
        // hapus marker
        const marker_to_remove = document.getElementById(
          `marker_toolbox_${feature.properties.uuid}`,
        );
        if (marker_to_remove) marker_to_remove.remove();

        // hapus data dan layer poi
        const source_id_poi = `geojson_poi_${feature.properties.uuid}`;
        dispatch(remove_source_and_layer_from_map(source_id_poi));
      }
    });

    // set feature yang diselect
    dispatch(
      set_value_toolbox({
        key: uuid_name,
        value: [],
      }),
    );

    dispatch(
      set_value_toolbox({
        key: "last_saved_feature_uuid",
        value: new_last_uuid,
      }),
    );

    set_modal_float(false);
  };

  // const on_rename_id_tool = () => {
  //   const new_features = features.map((f) => {
  //     if (single_selected === f.properties.uuid) {
  //       return {
  //         ...f,
  //         properties: {
  //           ...f.properties,
  //           id_tool: new_id_tool,
  //         }
  //       }
  //     }
  //     return f;
  //   });

  //   console.log("new_features", new_features);

  //   // dispatch(
  //   //   set_value_toolbox({
  //   //     key: mode_toolbox,
  //   //     value: new_features,
  //   //   }),
  //   // );
  //   set_modal_rename_tool(false);
  // }


  //content
  let description_content = null;
  if (single_selected_feature) {
    const { delta_elevation_m, length_m, elevation_min, elevation_max, elevation_avg } = single_selected_feature.properties || {};
    description_content = (
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "15px" }}>
        <p style={{ fontSize: "14px", fontWeight: 700 }}>Details</p>
        <div style={{ fontSize: "12px", fontWeight: 400, display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {(delta_elevation_m || delta_elevation_m === 0) && <div>Diff: <p style={{ fontSize: "16px", fontWeight: 600 }}>{Intl.NumberFormat("id-ID").format(delta_elevation_m)}m</p></div>}
          {(length_m || length_m === 0) && <div>Len: <p style={{ fontSize: "16px", fontWeight: 600 }}>{Intl.NumberFormat("id-ID").format(length_m)}m</p></div>}
          {(elevation_min || elevation_min === 0) && <div>Min: <p style={{ fontSize: "16px", fontWeight: 600 }}>{Intl.NumberFormat("id-ID").format(elevation_min)}m</p></div>}
          {(elevation_max || elevation_max === 0) && <div>Max: <p style={{ fontSize: "16px", fontWeight: 600 }}>{Intl.NumberFormat("id-ID").format(elevation_max)}m</p></div>}
          {(elevation_avg || elevation_avg === 0) && <div>Avg: <p style={{ fontSize: "16px", fontWeight: 600 }}>{Intl.NumberFormat("id-ID").format(elevation_avg)}m</p></div>}
        </div>
      </div>
    )
  }



  let chart_item;
  if (single_selected) {
    if (loading_status && loading_item === "generate_elevation") {
      chart_item = (
        <section className="container_light background_grey_light outline_black">
          <p className="text_bold">
            {dict?.["Measuring elevation"]?.[language]}...
          </p>
        </section>
      );
    } else {
      const elevation_chart_item = elevation_chart_array.find(
        (item) => item.parent_uuid === single_selected
      );

      if (elevation_chart_item) {

        const chart_js_data = {
          labels: elevation_chart_item.distances?.map(item => item.toFixed(2)),
          datasets: [
            {
              label: "Elevation chart",
              labels: elevation_chart_item.distances,
              data: elevation_chart_item.data,
              backgroundColor: "#0ca5eb",
            },
          ],
        };

        chart_item = (
          <div>
            <hr style={{ height: "1px", backgroundColor: "#BABABA", opacity: 0.2 }} />
            <CHART_TEMPLATE
              type="line"
              height={200}
              style={{
                width: "100%",
              }}
              options={{
                hoverBackgroundColor: "#000000",
                animation: false,
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                  display: false,
                },
                indexAxis: "x",
                title: {
                  display: false,
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                scales: {
                  x: { // Configuration for the X-axis
                    title: {
                      display: true, // Set to true to show the title
                      text: 'Distance (m)' // The text you want to display
                    }
                  },
                  y: { // Configuration for the Y-axis
                    beginAtZero: true,
                    title: {
                      display: true, // Set to true to show the title
                      text: 'Elevation (m)' // The text you want to display
                    }
                  }
                }
              }}
              data={chart_js_data}
              use_legend={false}
              use_generate_array_color={false}
            />
          </div>
        );
      }

    }
  }

  const deleted_list = features.reduce(function (result, feature) {
    if (selected_row_toolbox_ids.includes(feature.properties.uuid)) {
      return result.concat(feature.properties.id_tool);
    }
    return result;
  }, []);

  // content
  const modal_delete_content = modal_delete && (
    <Modal
      isOpen={modal_delete}
      onClose={() => set_modal_delete(false)}
      modalSize="small"
      title="Confirmation"
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px", maxHeight: "400px", overflowY: "auto" }}>
        <p style={{ display: "inline" }}>{dict["Are you sure to delete"][language]}{` `}</p>
        <p style={{ display: "inline", fontWeight: 700, fontSize: "18px" }}>
          {deleted_list && array_to_sentence(deleted_list, "eng")}
        </p>
        <p style={{ display: "inline" }}>{`?`}</p>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "end",
          gap: "15px",
        }}
      >
        <button
          onClick={() => set_modal_delete(false)}
          className="button_pill button_white"
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_delete()}
          className="button_pill flex"
          style={{
            backgroundColor: "#BD0000",
            color: "white",
          }}
        >
          <img src={icon_trash} alt="Delete" />
          {dict["Delete"][language]}
        </button>
      </div>
    </Modal>
  );

  const float_menu = modal_float && (
    <FLOAT_MENU
      id="feature-menu"
      anchorEl={anchor}
      open={modal_float}
      onClose={() => set_modal_float(false)}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: "10px" }}>
        <button
          style={{ borderRadius: "3px", backgroundColor: "white" }}
          className="button_white"
          onClick={() => fly_to(single_selected)}
        >
          {dict?.["Fly to"]?.[language]}
        </button>
        {/* <button
          style={{ borderRadius: "3px", backgroundColor: "white" }}
          className="button_white"
          onClick={() => set_modal_rename_tool(true)}
        >
          {dict?.["Rename"]?.[language]}
        </button> */}
        <hr style={{ height: "1px", width: "100%", backgroundColor: "#BABABA", opacity: 0.2, margin: "0" }} />
        <button
          style={{ borderRadius: "3px", backgroundColor: "white", color: "#BD0000" }}
          className="button_white"
          onClick={() => on_single_delete()}
        >
          {dict?.["Delete"]?.[language]}
        </button>
      </div>

    </FLOAT_MENU>
  )

  const modal_save_content = modal_save_tool && (
    <Modal
      isOpen={modal_save_tool}
      onClose={() => set_modal_save_tool(false)}
      modalSize="small"
      title={dict["Give a name"][language]}
      is_hide="hide"
    >
      <div style={{ marginBottom: "8px" }}>
        <p style={{ display: "inline", fontWeight: 600, fontSize: "14px" }}>
          {dict["Layer Name"][language]}
        </p>
      </div>

      <div style={{ marginBottom: "25px" }}>
        <input
          type="text"
          style={{ borderRadius: "20px", padding: "0 15px 0 15px" }}
          value={new_layer_name}
          onChange={(e) => set_new_layer_name(e.target.value)}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
        <button
          onClick={() => set_modal_save_tool(false)}
          className="button_pill flex"
          style={{
            border: "1px solid black",
            color: "black",
          }}
        >
          {dict["Cancel"][language]}
        </button>
        <button
          onClick={() => on_save()}
          className="button_pill flex"
          style={{
            backgroundColor: "black",
            color: "white",
          }}
        >
          {dict["Save"][language]}
        </button>
      </div>
    </Modal>
  );

  // const modal_rename_content = modal_rename_tool && (
  //   <Modal
  //     isOpen={modal_rename_tool}
  //     onClose={() => set_modal_rename_tool(false)}
  //     modalSize="small"
  //     title={dict["Rename"][language]}
  //     is_hide="hide"
  //   >
  //     <div style={{ marginBottom: "8px" }}>
  //       <p style={{ display: "inline", fontWeight: 600, fontSize: "14px" }}>
  //         ID Tool Name
  //       </p>
  //     </div>

  //     <div style={{ marginBottom: "25px" }}>
  //       <input
  //         type="text"
  //         style={{ borderRadius: "20px", padding: "0 15px 0 15px" }}
  //         value={new_id_tool}
  //         onChange={(e) => set_new_id_tool(e.target.value)}
  //       />
  //     </div>

  //     <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
  //       <button
  //         onClick={() => set_modal_rename_tool(false)}
  //         className="button_pill flex"
  //         style={{
  //           border: "1px solid black",
  //           color: "black",
  //         }}
  //       >
  //         Cancel
  //       </button>
  //       <button
  //         onClick={() => on_rename_id_tool()}
  //         className="button_pill flex"
  //         style={{
  //           backgroundColor: "black",
  //           color: "white",
  //         }}
  //       >
  //         Save
  //       </button>
  //     </div>
  //   </Modal>
  // );

  return (
    <>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "30px 20px 25px 20px",
        }}
      >
        <button
          onClick={() => on_back(true)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontWeight: 700,
            width: "fit-content",
            padding: "2px 10px",
            borderRadius: "2px",
          }}
        >
          <ArrowBackIos style={{ fontSize: "12px" }} />
          {dict["Back to Menu"][language]}
        </button>
      </section>

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          margin: "30px 20px 25px 20px",
        }}
      >
        <div>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>{dict["Results"][language]}</span>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            {dict["The elevation difference between two map points has been successfully calculated."][language]}{" "}
          </p>
        </div>
      </section>

      {/* <section className="container_light margin_bottom background_grey_light outline_black">
        <p className="text_bold">{dict?.["Elevation"]?.[language]}</p>
        <p className="text_small">
          {
            dict?.[
            "Measure elevation samples of the cross section along the line"
            ]?.[language]
          }
        </p>

      </section> */}

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          margin: "20px 0px 15px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            margin: "0px 27px 0px 27px",
          }}
        >
          <label
            style={{ fontWeight: 700, fontSize: "0.875rem", color: "#B2B2B2" }}
          >
            {showing_tab === "table" ? "Table" : "Chart"}
          </label>
          <Select
            style={{
              height: "28px",
              marginLeft: "10px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
            }}
            value={showing_tab}
            onChange={(e) => handle_tab_change(e)}
          >
            <MenuItem value={"table"}>{dict["Table"][language]}</MenuItem>
            <MenuItem value={"chart"}>Chart</MenuItem>
          </Select>
        </div>


        {showing_tab === "table" &&
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: "10px",
                margin: "0 27px 0px 27px",
              }}
            >
              <SolidCheckbox
                id="select_all"
                checked={selected_all}
                onChange={() => on_select_all()}
                style={{ width: "18px", height: "18px", cursor: "pointer" }}
              />
              <label
                htmlFor="select_all"
                style={{ fontSize: "14px", cursor: "pointer" }}
              >
                {dict["Select All"][language]}
              </label>
            </div>

            {mode_toolbox !== "grouping" && (
              <div
                style={{ maxHeight: "200px", overflowY: "auto", position: "relative" }}
              >
                <table className="toolbox_table"
                >
                  <thead>
                    <tr>
                      <th>{dict["Select"][language]}</th>
                      <th>No.</th>
                      <th>ID Tool</th>
                      <th>{dict["Difference"][language]}</th>
                      {/* {
                    fields.map(field => (
                      <th
                        key={field.key}
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {field.name}</th>
                    ))
                  } */}
                    </tr>
                  </thead>
                  <tbody>
                    {features.map((item, idx) => {
                      const viewStatus = visible_features.includes(item.properties.uuid);

                      return (
                        <React.Fragment key={idx}>
                          <tr
                            style={{ backgroundColor: last_saved_feature_uuid_index < idx ? "lightGrey" : "white" }}
                            onClick={() => fly_to(item.properties.uuid)}
                          >
                            <td style={{ display: "flex", alignItems: "center", gap: "20px", justifyContent: "center" }}>
                              <SolidCheckbox
                                checked={selected_row_toolbox_ids.includes(
                                  item.properties.uuid,
                                )}
                                onChange={() =>
                                  on_select_row_uuid(item.properties.uuid)
                                }
                                style={{ width: "18px", height: "18px" }}
                              />
                              <button
                                style={{
                                  color: "black",
                                }}
                                onClick={() => on_hide(item.properties.uuid)}
                              >
                                <ICON_VIEW
                                  color={viewStatus ? "#000" : "#b7b7b7"}
                                  strokeWidth={viewStatus ? 4 : 3}
                                  style={{ width: "18px", height: "18px" }}
                                />
                              </button>
                            </td>

                            <td>{idx + 1}</td>
                            <td>{item?.properties?.id_tool}</td>
                            <td>
                              {!isNaN(item?.properties?.delta_elevation_m) ?
                                Intl.NumberFormat("id-ID").format(item?.properties?.delta_elevation_m) : "-"}
                            </td>
                            {/* {
                          fields.map(field => (
                            <td
                              key={`${field.key}_${item?.properties?.uuid}`}
                              style={{
                                maxWidth: "100px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                            >{item?.properties?.[field.name]}</td>
                          ))
                        } */}
                          </tr>
                        </React.Fragment>
                      );
                    })}
                    {loading_status &&
                      <tr>
                        <td colSpan="4">
                          {dict?.["Measuring elevation"]?.[language]}...
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            )}

            {selected_row_toolbox_ids?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "5px",
                }}
              >
                <button
                  onClick={() => on_clear_select()}
                  className="button_pill button_white"
                >
                  {dict["Cancel"][language]}
                </button>
                <button
                  onClick={() => set_modal_delete(true)}
                  className="button_pill flex"
                  style={{
                    backgroundColor: "#BD0000",
                    color: "white",
                  }}
                >
                  <img src={icon_trash} alt="Delete" />
                  {dict["Delete"][language]}
                </button>
                <button
                  onClick={() => set_modal_save_tool(true)}
                  title={`${dict["Save"][language]}${language === "eng" ? " the" : ""} ${dict["Elevations"][language]}`}
                  className="button_pill flex"
                  style={{
                    backgroundColor: "black",
                    color: "white",
                  }}
                >
                  {dict["Save"][language]}
                </button>

              </div>
            )}
          </>
        }

        {showing_tab === "chart" &&
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
                margin: "0px 27px",
              }}
            >
              <p style={{ fontSize: "12px", fontWeight: "500" }}>
                Elevation contour along cross section (m)
              </p>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                margin: "0px 27px",
              }}
            >
              <SolidCheckbox
                id="select_all"
                checked={chart_select_mode}
                onChange={(e) => set_chart_select_mode(e.target.checked)}
                style={{ width: "18px", height: "18px", cursor: "pointer" }}
              />
              <label
                htmlFor="select_all"
                style={{ fontSize: "14px", cursor: "pointer" }}
              >
                {dict["Select"][language]}
              </label>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                gap: "10px",
                margin: "0 27px",
                maxHeight: "100px",
                flexWrap: "wrap",
                overflowY: "auto",
                padding: "10px",
              }}
            >
              {features.map(feature => {
                return (
                  <button
                    style={{
                      border: `1px solid ${single_selected === feature.properties.uuid ? "#000000" : "#ABABAB4D"}`,
                      borderRadius: "5px",
                      padding: "6px 10px",
                      height: "32px",
                      fontSize: "12px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => { set_single_selected(feature.properties.uuid) }}
                    key={feature.properties.uuid}
                  >
                    {chart_select_mode && <SolidCheckbox
                      id="select_all"
                      checked={selected_row_toolbox_ids.includes(feature.properties.uuid)}
                      onChange={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        on_select_row_uuid(feature.properties.uuid)
                      }
                      }
                      style={{ width: "12px", height: "12px", cursor: "pointer", marginRight: "5px" }}
                    />}
                    <p>{`${feature.properties.id_tool}`}</p>
                    <div
                      className="hover_border"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        marginLeft: "10px",
                        borderRadius: "3px",
                      }}
                      onClick={(e) => {
                        // e.stopPropagation();
                        set_anchor(e.currentTarget);
                        set_modal_float(true);
                      }}
                    >
                      <MoreVert style={{ width: "16px", height: "16px", color: "#ABABAB" }} />
                    </div>
                  </button>
                )

              })}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "20px",
                margin: "0px 27px",
              }}
            >
              {chart_item}
              {description_content}
              {selected_row_toolbox_ids?.length > 0 && chart_select_mode && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <button
                    onClick={() => on_clear_select()}
                    className="button_pill button_white"
                  >
                    {dict["Cancel"][language]}
                  </button>
                  <button
                    onClick={() => set_modal_delete(true)}
                    className="button_pill flex"
                    style={{
                      backgroundColor: "#BD0000",
                      color: "white",
                    }}
                  >
                    <img src={icon_trash} alt="Delete" />
                    {dict["Delete"][language]}
                  </button>
                  <button
                    onClick={() => set_modal_save_tool(true)}
                    title={`${dict["Save"][language]}${language === "eng" ? " the" : ""} ${dict["Elevations"][language]}`}
                    className="button_pill flex"
                    style={{
                      backgroundColor: "black",
                      color: "white",
                    }}
                  >
                    {dict["Save"][language]}
                  </button>

                </div>
              )}
            </div>
          </>
        }


      </section>

      {modal_delete_content}
      {float_menu}
      {modal_save_content}
      {/* {modal_rename_content} */}
    </>
  );

}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(TOOLBOX_DETAIL_ELEVATION);
